import { z } from 'zod'

export const VServerPtrRecord = z.object({
  ip: z.string(),
  hostname: z.string().nullable().optional(),
  available: z.boolean().optional()
})
export type VServerPtrRecord = z.infer<typeof VServerPtrRecord>

export const VServerFirewallDirection = z.enum(['in', 'out'])
export type VServerFirewallDirection = z.infer<typeof VServerFirewallDirection>

export const VServerFirewallAction = z.enum(['accept', 'drop', 'reject'])
export type VServerFirewallAction = z.infer<typeof VServerFirewallAction>

export const VServerFirewallProtocol = z.enum(['tcp', 'udp', 'icmp', 'ipv6-icmp'])
export type VServerFirewallProtocol = z.infer<typeof VServerFirewallProtocol>

export const VServerFirewallRule = z.object({
  position: z.number(),
  direction: VServerFirewallDirection,
  action: VServerFirewallAction,
  protocol: z.string().nullable().optional(),
  sport: z.string().nullable().optional(),
  dport: z.string().nullable().optional(),
  source: z.string().nullable().optional(),
  dest: z.string().nullable().optional(),
  comment: z.string().nullable().optional(),
  enable: z.boolean().default(true),
  // The same on every rule of one list; an update or delete sends it back.
  digest: z.string().optional()
})
export type VServerFirewallRule = z.infer<typeof VServerFirewallRule>

export const VServerFirewallRuleInput = z.object({
  direction: VServerFirewallDirection,
  action: VServerFirewallAction,
  protocol: VServerFirewallProtocol.optional(),
  sport: z.string().optional(),
  dport: z.string().optional(),
  source: z.string().optional(),
  dest: z.string().optional(),
  comment: z.string().max(128).optional(),
  enable: z.boolean().default(true)
})
export type VServerFirewallRuleInput = z.infer<typeof VServerFirewallRuleInput>
